export default __webpack_public_path__ + "static/media/dash-dash-logo.c8855f96.svg";